import { Dispatch, SetStateAction, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Button,
  Checkbox,
  Autocomplete,
  FormControlLabel,
} from "@mui/material";
import { showError, showToast } from "../constants/toasts";
import {
  useAddMemberToMultipleGroupMutation,
  useLazyGetGroupByMemberQuery,
  useLazyGetMemberGroupsQuery,
} from "../service/user";
import { Group } from "../types/General";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  memberId: string | undefined;
}

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddtoGroup({
  open,
  onClose,
  setOpen,
  memberId,
}: AddCategoryModalProps) {
  const [addMember] = useAddMemberToMultipleGroupMutation();
  const [getGroups] = useLazyGetMemberGroupsQuery();
  const [getGroupById] = useLazyGetGroupByMemberQuery();
  const [groupData, setGroupData] = useState<Group[]>([]);

  const [autoCompleteOpen, setAutoCompleteOpen] = useState(true);
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);

  const handleUsersChange = (event: any, value: any[]) => {
    const selectedGroupIds = value.map((group) => group.groupId);
    setSelectedUsers(selectedGroupIds);
  };

  const getGroupApi = async () => {
    try {
      const response = await getGroups({
        page: 1,
        search: "",
      }).unwrap();
      if (response.status === 200) {
        setGroupData(response?.data || []);
        // setCount(response?.data?.totalCount);
      } else {
        setGroupData([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const getGroupByMember = async () => {
    try {
      const response = await getGroupById({
        id: memberId,
      }).unwrap();
      if (response.status === 200) {
        let groupsId = response?.data?.map((item: any) => item?.groupId);

        setSelectedUsers(groupsId);
      } else {
        setSelectedUsers([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const addMemberApi = async () => {
    if (!selectedUsers?.length) {
      showError("Please select group");
      return;
    }

    const body = {
      groupIds: selectedUsers,
      memberId,
    };

    try {
      const response = await addMember(body).unwrap();
      if (response.status === 200) {
        setOpen(false);
        showToast(response?.message);
        // setSelectedUsers([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getGroupApi();
  }, []);

  useEffect(() => {
    getGroupByMember();
  }, []);

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2>Add </h2>
            <div
              role="button"
              tabIndex={0}
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group w_50">
              <label>Groups</label>

              <Autocomplete
                multiple
                disableCloseOnSelect
                options={groupData}
                value={groupData?.filter((option) =>
                  selectedUsers?.includes(option?.groupId)
                )}
                onChange={handleUsersChange}
                getOptionLabel={(option) => option?.groupName}
                isOptionEqualToValue={(option: any, value: any) =>
                  option?.groupId === value?.groupId
                }
                onOpen={() => setAutoCompleteOpen(true)}
                onClose={() => setAutoCompleteOpen(false)}
                renderOption={(props, option: any, { selected }) => {
                  return (
                    <li {...props}>
                      <FormControlLabel
                        control={<Checkbox checked={selected} />}
                        name="option"
                        label={option?.groupName}
                      />
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Groups" />
                )}
              />
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_primary" onClick={addMemberApi}>
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
